import {Component, Input} from "@angular/core";

@Component({
  selector: "reportSummaryField",
  template: `
            <span class="label" [attr.id]="labelId">{{title}}</span>
            <span *ngIf="!path && !isNumber" class="detail" [attr.id]="detailId">{{detail}}</span>
            <span *ngIf="!path && isNumber" class="detail" [attr.id]="detailId">{{detail | number}}</span>
            <span *ngIf="path && path.length > 0" class="detail" [attr.id]="detailId">
                <a *ngIf="!isNumber" [routerLink]="path">{{detail}}</a>
                <a *ngIf="isNumber" [routerLink]="path">{{detail | number}}</a>
            </span>
    `,
})

export class ReportSummaryField {
    @Input() public prefix: string;
    @Input() public title: string;
    @Input() public detail: string;
    @Input() public path: Array<any>;
    @Input() public isNumber: boolean = true;

    get labelId() {
        let prefix = this.prefix ? this.prefix : "";
        return `${prefix}${this.title.replace(/[^A-Z0-9]/ig,"")}SummaryFieldLabel`;
    }

    get detailId() {
        let prefix = this.prefix ? this.prefix : "";
        return `${prefix}${this.title.replace(/[^A-Z0-9]/ig,"")}SummaryFieldDetail`;
    }

}



// WEBPACK FOOTER //
// ./client/app/shared/reportControls/report-summary-field-component.ts